import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MatButtonModule, MatButton } from '@angular/material/button';
import { MatDialog, MatDialogModule, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import config from '../../../../auth_config.json';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  readonly dialog = inject(MatDialog);
  readonly build = (config as typeof config & { build?: string }).build ?? '';

  constructor() { }

  ngOnInit() {
  }
  openDialog() {
    const dialogRef = this.dialog.open(CookieDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
}

@Component({
  selector: './footer.component.cookies',
  templateUrl: './footer.component.cookies.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class CookieDialogComponent {


  constructor() { }
}
